import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  COLOR_CODES_FABRIC,
  MATERIAL_OPTIONS,
  ROOM_OPTIONS,
} from 'commons/constants';
import ColorsFilter from 'components/essentials/ColorsFilter';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';

const colorsList = COLOR_CODES_FABRIC.map(obj => Object.keys(obj)[0]);

const InspirationFiltersTop = ({ filterState, filterActions }) => {
  const materialItems = useMemo(
    () =>
      MATERIAL_OPTIONS.map(option => ({
        label: option.label,
        id: option.value,
        isSelected: filterState.materialFilter === option.value,
        onClick: () => {
          filterActions.setMaterialFilter(
            filterState.materialFilter === option.value ? '' : option.value
          );
        },
      })),
    [filterState.materialFilter, filterActions]
  );

  const roomItems = useMemo(
    () =>
      ROOM_OPTIONS.map(option => ({
        label: option.label,
        id: option.value,
        isSelected: filterState.roomFilter === option.value,
        onClick: () => {
          filterActions.setRoomFilter(
            filterState.roomFilter === option.value ? '' : option.value
          );
        },
      })),
    [filterState.roomFilter, filterActions]
  );

  return (
    <>
      <ShopByHeaderSection label="Material">
        <ToggleButtonGroup items={materialItems} tabIndex="0" />
      </ShopByHeaderSection>

      <ShopByHeaderSection label="Color">
        <ColorsFilter
          colors={colorsList}
          selectedColors={filterState.colorFilters}
          onSelectColor={filterActions.toggleColorFilter}
          variant="ShopByHeaderSection"
        />
      </ShopByHeaderSection>

      <ShopByHeaderSection label="Shop by Room">
        <TogglePillGroup items={roomItems} variant="ShopByHeaderSection" />
      </ShopByHeaderSection>
    </>
  );
};

InspirationFiltersTop.propTypes = {
  filterState: PropTypes.object.isRequired,
  filterActions: PropTypes.object.isRequired,
};

export default InspirationFiltersTop;
